/**
 * The two-letter code a meeting row shows for a language.
 *
 * Not the display name: these sit in a chip beside a truncated title, and a full name would take
 * the room the title needs. Its own module rather than living with `LanguagePair` because a file
 * that exports both a component and a function loses fast refresh — which is what the lint rule
 * `react-refresh/only-export-components` is there to say.
 */
export function getLanguageLabel(language: string): string {
  return language.slice(0, 2).toUpperCase()
}
